import { Designer, Nullable, Profile, Team } from "@brg/api";
import { ComputedTeam } from "./types/computed/ComputedTeam";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export const ARCHIVE_TEAM_STATUS = 1;
export const DRAFT_TEAM_STATUS = 2;
export const PUBLISHED_TEAM_STATUS = 0;
export const ACTIVE_ARCHIVE_TEAM_STATUS = 3;
export const UNDER_APPROVAL_TEAM_STATUS = 4;
export const HIDDEN_TEAM_STATUS = 5;
export const REJECTED_TEAM_STATUS = 6;
export const APPROVED_LMS_TEAM_STATUS = 7;
export const WILL_BE_DELETED_TEAM_STATUS = 10;

/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusRejected = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([REJECTED_TEAM_STATUS].includes(v.status));
/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusUnderApproval = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([UNDER_APPROVAL_TEAM_STATUS].includes(v.status));
/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusPublished = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([PUBLISHED_TEAM_STATUS].includes(v.status));

/**
 * Предикат орг - черновиков
 *
 * @param v
 * @constructor
 */
 export const TeamStatusDrafts = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === DRAFT_TEAM_STATUS;

/**
 * Предикат орг - удаленных
 *
 * @param v
 * @constructor
 */
 export const TeamStatusDeleted = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === ARCHIVE_TEAM_STATUS;

/**
 * Предикат орг - активный архивный (для лмс каналов)
 *
 * @param v
 * @constructor
 */
export const TeamStatusActiveArchived = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === ACTIVE_ARCHIVE_TEAM_STATUS;


export const hasDefaultChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && v?.teamId === p?.defaultEduChannelId

export const hasPersonalChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && v?.ownersIDs?.length === 1 && 
  v?.moderationType === ModerationType.Outer &&
  v?.ownersIDs?.includes(p?.accountId)

export const hasParticipantChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && 
  v?.moderationType === ModerationType.ChannelGroupOrCourse &&
  !!v?.ownersIDs?.includes(p?.accountId)
  
export const isPersonalOrDefaultChannel = (team?: ComputedTeam, profile?: Profile) => {
    if (!(team || profile))return false;

    if (profile?.defaultEduChannelId) {
      return profile?.defaultEduChannelId=== team?.teamId
    }

    return team?.ownersIDs?.length === 1 && 
        team?.ownersIDs?.includes(profile?.accountId ?? '') && 
        team?.moderationType === ModerationType.Outer
}

export const getDefaultChannelId = (team?: ComputedTeam, profile?: Profile) => {
    if (!(team || profile))return false;

    if (profile?.defaultEduChannelId) {
        return profile?.defaultEduChannelId
    }
    return team?.ownersIDs?.length === 1 && 
        team?.ownersIDs?.includes(profile?.accountId ?? '') && 
        team?.moderationType === ModerationType.Outer && team?.teamId
}
  import { Designer, Nullable, Profile, Team } from "@brg/api";
import { ComputedTeam } from "./types/computed/ComputedTeam";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export const ARCHIVE_TEAM_STATUS = 1;
export const DRAFT_TEAM_STATUS = 2;
export const PUBLISHED_TEAM_STATUS = 0;
export const ACTIVE_ARCHIVE_TEAM_STATUS = 3;
export const UNDER_APPROVAL_TEAM_STATUS = 4;
export const HIDDEN_TEAM_STATUS = 5;
export const REJECTED_TEAM_STATUS = 6;
export const APPROVED_LMS_TEAM_STATUS = 7;
export const WILL_BE_DELETED_TEAM_STATUS = 10;

/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusRejected = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([REJECTED_TEAM_STATUS].includes(v.status));
/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusUnderApproval = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([UNDER_APPROVAL_TEAM_STATUS].includes(v.status));
/**
 * Предикат опубликованных орг
 *
 * @param v
 * @constructor
 */
export const TeamStatusPublished = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && ([PUBLISHED_TEAM_STATUS].includes(v.status));

/**
 * Предикат орг - черновиков
 *
 * @param v
 * @constructor
 */
 export const TeamStatusDrafts = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === DRAFT_TEAM_STATUS;

/**
 * Предикат орг - удаленных
 *
 * @param v
 * @constructor
 */
 export const TeamStatusDeleted = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === ARCHIVE_TEAM_STATUS;

/**
 * Предикат орг - активный архивный (для лмс каналов)
 *
 * @param v
 * @constructor
 */
export const TeamStatusActiveArchived = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
): boolean => !!v && v.status === ACTIVE_ARCHIVE_TEAM_STATUS;


export const hasDefaultChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && v?.teamId === p?.defaultEduChannelId

export const hasPersonalChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && v?.ownersIDs?.length === 1 && 
  v?.moderationType === ModerationType.Outer &&
  v?.ownersIDs?.includes(p?.accountId)

export const hasParticipantChannel = (
  v: Nullable<Team | Team<"Global"> | ComputedTeam>
, p: Designer | Profile): boolean => !!v && !!p && 
  v?.moderationType === ModerationType.ChannelGroupOrCourse &&
  !!v?.ownersIDs?.includes(p?.accountId)
  
export const isPersonalOrDefaultChannel = (team?: ComputedTeam, profile?: Profile) => {
    if (!(team || profile))return false;

    if (profile?.defaultEduChannelId) {
      return profile?.defaultEduChannelId=== team?.teamId
    }

    return team?.ownersIDs?.length === 1 && 
        team?.ownersIDs?.includes(profile?.accountId ?? '') && 
        team?.moderationType === ModerationType.Outer
}

export const getDefaultChannelId = (team?: ComputedTeam, profile?: Profile) => {
    if (!(team || profile))return false;

    if (profile?.defaultEduChannelId) {
        return profile?.defaultEduChannelId
    }
    return team?.ownersIDs?.length === 1 && 
        team?.ownersIDs?.includes(profile?.accountId ?? '') && 
        team?.moderationType === ModerationType.Outer && team?.teamId
}
  